module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img76.3cd4b198.jpg";